import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useZakeke } from '@zakeke/zakeke-configurator-react';
import { MOBILE_BREAKPOINT } from '../../Store';

interface ViewerModeTabsProps {
	onOpenAIStudio: (mode: 'staging' | 'tryon') => void;
	isProductStagingEnabled: boolean;
	isVtoEnabled: boolean;
}

export const ViewerModeTabs: React.FC<ViewerModeTabsProps> = ({ onOpenAIStudio, isProductStagingEnabled, isVtoEnabled }) => {
	const { T_static } = useZakeke();
	const T = useMemo(() => ({ _: T_static }), [T_static]);

	return (
		<TabsContainer>
			<TabsSwitch role='radiogroup' aria-label={T._('Select mode')}>
				<DesignerTab role='radio' aria-checked='true' aria-label={T._('Designer mode')}>
					{T._('Designer')}
				</DesignerTab>
				{isProductStagingEnabled && (
					<AITab
						onClick={() => onOpenAIStudio('staging')}
						role='radio'
						aria-checked='false'
						aria-label={T._('Product Staging mode')}
					>
						{T._('Product Staging')}
					</AITab>
				)}
				{isVtoEnabled && (
					<AITab
						onClick={() => onOpenAIStudio('tryon')}
						role='radio'
						aria-checked='false'
						aria-label={T._('Virtual Try-on mode')}
					>
						{T._('Virtual Try-on')}
					</AITab>
				)}
			</TabsSwitch>
		</TabsContainer>
	);
};

const TabsContainer = styled.div`
	position: absolute;
	top: 12px;
	left: 12px;
	z-index: 5;

	@media (max-width: ${MOBILE_BREAKPOINT}px) {
		top: 8px;
		left: 8px;
		right: 8px;
		display: flex;
		justify-content: center;
	}
`;

const TabsSwitch = styled.div`
	display: inline-flex;
	gap: 6px;
	padding: 3px;

	@media (max-width: ${MOBILE_BREAKPOINT}px) {
		padding: 2px;
		gap: 4px;
	}
`;

const DesignerTab = styled.button`
	padding: 7px 16px;
	font-size: 12px;
	font-weight: 500;
	color: white;
	cursor: default;
	border-radius: 9999px;
	transition: all 0.3s ease;
	white-space: nowrap;
	text-align: center;
	background: #0069d3;
	border: none;
	outline: none;

	@media (max-width: ${MOBILE_BREAKPOINT}px) {
		padding: 5px 10px;
		font-size: 11px;
		border-radius: 20px;
	}
`;

const AITab = styled.button`
	padding: 7px 16px;
	font-size: 12px;
	font-weight: 500;
	color: #666;
	cursor: pointer;
	border-radius: 9999px;
	transition: all 0.3s ease;
	white-space: nowrap;
	text-align: center;
	background: transparent;
	border: none;
	outline: none;

	&:hover,
	&:active,
	&:focus {
		background: linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(168, 85, 247) 50%, rgb(236, 72, 153) 100%);
		color: white;
	}

	@media (max-width: ${MOBILE_BREAKPOINT}px) {
		padding: 5px 10px;
		font-size: 11px;
		border-radius: 20px;
	}
`;
